export function CoreQConfig (
  $qProvider: ng.IQProvider
) {
  $qProvider.errorOnUnhandledRejections(false);
};
